var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericAvatar = function SvgGenericAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#ECE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    d: "M13.72 6.637c0 1.404-1.115 2.544-2.492 2.544-1.376 0-2.491-1.14-2.491-2.544s1.115-2.543 2.491-2.543 2.492 1.14 2.492 2.543m.324 10.667H8.262C7.565 17.304 7 15.92 7 15.21v-2.398c0-1.779 1.413-3.221 3.156-3.221h1.994c1.743 0 3.156 1.442 3.156 3.22v2.4c0 .71-.565 2.093-1.262 2.093"
  }))));
};
export default SvgGenericAvatar;